import withDismissible from "../WithDismissible";
import NotificationsOptInTile from "../NotificationsOptInTile";

export default withDismissible({
  component: NotificationsOptInTile,
  shouldRenderKey: "showNotificationsOptInTile"
});
